var map = {
	"./de.json": [
		3047,
		47
	],
	"./en.json": [
		2511
	],
	"./es.json": [
		2792,
		411
	],
	"./fr.json": [
		2364,
		364
	],
	"./it.json": [
		5573,
		573
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5825;
module.exports = webpackAsyncContext;